import { singletonAtom } from '@/context/atoms/helper/singletonAtom';
import { type AuthMechanism } from '@ekkogmbh/apisdk';
import { WebEamAuthMechanism } from '@/helper/auth/WebEamAuthMechanism';
import { publicConfigAtom } from '@/context/atoms/publicConfig';

export const webEamAuthMechanismAtom = singletonAtom<Promise<AuthMechanism>>(async (get) => {
  const publicConfig = await get(publicConfigAtom);

  const e2eWEBEAM = {
    URL: publicConfig.env.WEBEAM_E2E_URL,
    CLIENT_ID: publicConfig.env.WEBEAM_E2E_CLIENT_ID,
    CLIENT_SECRET: publicConfig.env.WEBEAM_E2E_CLIENT_SECRET,
    redirectUri: publicConfig.env.WEBEAM_E2E_REDIRECT_URI,
    realmPath: publicConfig.env.WEBEAM_E2E_REALM_PATH,
  };

  const e2eSettings = {
    service: 'WEBEAM',
    log: true,
    WEBEAM: {
      ...e2eWEBEAM,
    },
  };

  return new WebEamAuthMechanism(null, e2eSettings);
});
